import React, { useState } from "react";
import { Link } from "react-router-dom";
import Utils from "../../utility";
import ClickOutside from "../../common/components/clickOutside";
import Dropdown from "../../common/components/dropdown";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const getAccuracyClasses = (pct) => {
  if (pct >= 80) return "bg-green-60 text-green-70";
  if (pct >= 60) return "bg-orange-20 text-orange-30";
  return "bg-red-40 text-red-50";
};

const getAccuracyBarClass = (pct) => {
  if (pct >= 80) return "bg-green-50";
  if (pct >= 60) return "bg-orange-40";
  return "bg-red-30";
};

const Report = ({
  setDate,
  setSelectTime,
  setSelectProcessedTime,
  selectTime,
  setProcessedDate,
  date,
  selectProcessedTime,
  processedDate,
  report,
  setFeebackDate,
  feedbackDate,
  setSelectFeedbackTime,
  selectFeedbackTime,
  withHours,
  setWithHours,
  setSelectedVersion,
  selectedVersion,
  loading
}) => {
  const [open, setOpen] = useState(false);
  const [openProcessed, setOpenProcessed] = useState(false);
  const [range, setRange] = useState({
    startDate: null,
    endDate: new Date(""),
    key: "date"
  });
  const [openFeedback, setOpenFeedback] = useState(false);
  const [rangeProcessed, setRangeProcessed] = useState({
    startDate: null,
    endDate: new Date(""),
    key: "selection"
  });
  const [feedbackProcessed, setFeedbackProcessed] = useState({
    startDate: null,
    endDate: new Date(""),
    key: "feedback"
  });
  const handleDateSelect = (ranges) => {
    const { startDate, endDate } = ranges.date;

    const formattedStartDate = Utils.formatDateYear(startDate);
    const formattedEndDate = Utils.formatDateYear(endDate);

    setRange({
      ...range,
      startDate: startDate,
      endDate: endDate
    });

    setDate((prev) => ({
      ...prev,
      startDate: formattedStartDate,
      endDate: formattedEndDate
    }));
  };
  const handleSelect = (value) => {
    setSelectTime(value);
    if (value === "Custom") {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };
  const handleSelectProcessed = (value) => {
    setSelectProcessedTime(value);
    if (value === "Custom") {
      setOpenProcessed(true);
    } else {
      setOpenProcessed(false);
    }
  };
  const handleSelectFeedback = (value) => {
    setSelectFeedbackTime(value);
    if (value === "Custom") {
      setOpenFeedback(true);
    } else {
      setOpenFeedback(false);
    }
  };
  const handleClearFilters = () => {
    setSelectTime("All");

    setRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "date"
    });
    setSelectProcessedTime("Last 14 days");
    setSelectFeedbackTime("All");
    setSelectedVersion("Latest");
  };
  const handleDateSelectProcessed = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    const formattedStartDate = Utils.formatDate(startDate);
    const formattedEndDate = Utils.formatDate(endDate);

    setRangeProcessed({
      ...rangeProcessed,
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate
    });

    setProcessedDate((prev) => ({
      ...prev,
      startDate: formattedStartDate,
      endDate: formattedEndDate
    }));
  };
  const handleFeedbackProcessed = (ranges) => {
    const { startDate, endDate } = ranges.feedback;

    const formattedStartDate = Utils.formatDate(startDate);
    const formattedEndDate = Utils.formatDate(endDate);

    setFeedbackProcessed({
      ...feedbackProcessed,
      startDate: ranges.feedback.startDate,
      endDate: ranges.feedback.endDate
    });

    setFeebackDate((prev) => ({
      ...prev,
      startDate: formattedStartDate,
      endDate: formattedEndDate
    }));
  };
  const handleRedirect = (url, isFeedbackDateRequired = true) => {
    let newUrl = `${url}&versionScope=${selectedVersion}`;

    // Handle non-custom time filters
    if (selectProcessedTime && selectProcessedTime !== "Custom") {
      newUrl += `&processedTime=${selectProcessedTime}`;
    }

    if (selectTime && selectTime !== "Custom") {
      newUrl += `&selectTime=${selectTime}`;
    }

    if (
      selectFeedbackTime &&
      selectFeedbackTime !== "Custom" &&
      isFeedbackDateRequired
    ) {
      newUrl += `&feedbackTime=${selectFeedbackTime}`;
    }

    // Handle custom date ranges
    if (selectTime === "Custom" && date?.startDate && date?.endDate) {
      newUrl += `&fromDate=${date.startDate}&toDate=${date.endDate}&selectTime=Custom`;
    }

    if (
      selectProcessedTime === "Custom" &&
      processedDate?.startDate &&
      processedDate?.endDate
    ) {
      newUrl += `&processedOnFrom=${processedDate.startDate}&processedOnTo=${processedDate.endDate}&processedTime=Custom`;
    }

    if (
      selectFeedbackTime === "Custom" &&
      feedbackDate?.startDate &&
      feedbackDate?.endDate &&
      isFeedbackDateRequired
    ) {
      newUrl += `&feedbackFromDate=${feedbackDate.startDate}&feedbackToDate=${feedbackDate.endDate}&feedbackTime=Custom`;
    }

    return newUrl;
  };

  return (
    <div>
      {" "}
      <div className="flex gap-3">
        <div className="flex items-center gap-2 pt-2">
          <span className="font-InterRegular text-ft20-28">Total Claims:</span>
          <span className="font-InterSemiBold text-ft25-30">
            {report?.totalClaims}
          </span>
        </div>
        <div className="flex gap-2 pl-5">
          <ClickOutside isOpen={open} onClickOutside={() => setOpen(false)}>
            <div className="relative">
              <Dropdown
                width={"min-w-30"}
                text={"Date"}
                value={selectTime}
                list={["All", "Last 14 days", "Previous month", "Custom"]}
                handleSelect={handleSelect}
                setOpenCalendar={setOpen}
                startDate={date?.startDate}
                endDate={date?.endDate}
              />
              {open && (
                <div className="absolute z-[999]">
                  <DateRange
                    ranges={[range]}
                    onChange={handleDateSelect}
                    className="rounded-md border border-grey-30"
                    showDateDisplay={false}
                    showMonthAndYearPickers={false}
                  />
                </div>
              )}
            </div>
          </ClickOutside>
          <ClickOutside
            isOpen={openProcessed}
            onClickOutside={() => setOpenProcessed(false)}
          >
            <div className="relative">
              <Dropdown
                width={"min-w-30"}
                text={"Processed"}
                value={selectProcessedTime}
                list={["All", "Last 14 days", "Previous month", "Custom"]}
                handleSelect={handleSelectProcessed}
                setOpenCalendar={setOpenProcessed}
                startDate={processedDate?.startDate}
                endDate={processedDate?.endDate}
              />
              {openProcessed && (
                <div className="absolute z-[999]">
                  <DateRange
                    ranges={[rangeProcessed]}
                    onChange={handleDateSelectProcessed}
                    className="rounded-md border border-grey-30"
                    showDateDisplay={false}
                    showMonthAndYearPickers={false}
                  />
                </div>
              )}
            </div>
          </ClickOutside>
          <ClickOutside
            isOpen={openFeedback}
            onClickOutside={() => setOpenFeedback(false)}
          >
            <div className="relative">
              <Dropdown
                width={"min-w-30"}
                text={"Feedback Date"}
                value={selectFeedbackTime}
                list={["All", "Last 14 days", "Previous month", "Custom"]}
                handleSelect={handleSelectFeedback}
                setOpenCalendar={setOpenFeedback}
                startDate={feedbackDate?.startDate}
                endDate={feedbackDate?.endDate}
              />
              {openFeedback && (
                <div className="absolute z-[999]">
                  <DateRange
                    ranges={[feedbackProcessed]}
                    onChange={handleFeedbackProcessed}
                    className="rounded-md border border-grey-30"
                    showDateDisplay={false}
                    showMonthAndYearPickers={false}
                  />
                </div>
              )}
            </div>
          </ClickOutside>

          <Dropdown
            width={"w-31"}
            text={"Processed Within Working Hours"}
            value={withHours}
            list={["All", "Yes", "No"]}
            handleSelect={setWithHours}
            setCurrentPage={() => {}}
          />
          <Dropdown
            width={"min-w-31"}
            text={"Version Scope"}
            value={selectedVersion}
            list={["All", "Latest"]}
            handleSelect={setSelectedVersion}
            // setCurrentPage={setCurrentPage}
          />
        </div>

        <div
          className="flex cursor-pointer items-center gap-1"
          onClick={handleClearFilters}
        >
          <span className="font-InterRegular text-ft14-17 text-blue-10">
            Clear
          </span>
          <img src="/images/clear.svg" alt="" />
        </div>
      </div>
      {loading ? (
        <div className="flex h-75vh items-center justify-center">
          <div className="loader "></div>
        </div>
      ) : (
        <div className="mt-5 grid w-full grid-cols-3 gap-5 xl:grid-cols-5">
          <div className="col-span-3 xl:col-span-5">
            <h3 className="mb-3 font-InterSemiBold text-ft16-24 text-black-10">
              Claim Processing Status
            </h3>
            <div className="grid w-full grid-cols-2 gap-4 xl:grid-cols-4">
              {report?.Success > 0 ? (
                <Link
                  to={handleRedirect(
                    "/inspection-claims?result=Success&report=true",
                    false
                  )}
                >
                  <div className="flex h-24 w-full flex-col justify-center gap-2 rounded-lg border border-l-4 border-grey-10 border-l-green-10 bg-white p-4">
                    <span className="font-InterRegular text-ft14-17 text-grey-50">
                      Processed Successfully
                    </span>
                    <span className="font-InterSemiBold text-ft25-30 text-blue-30 hover:underline">
                      {report.Success}
                    </span>
                  </div>
                </Link>
              ) : (
                <div className="flex h-24 w-full flex-col justify-center gap-2 rounded-lg border border-l-4 border-grey-10 border-l-green-10 bg-white p-4">
                  <span className="font-InterRegular text-ft14-17 text-grey-50">
                    Processed Successfully
                  </span>
                  <span className="font-InterSemiBold text-ft25-30 text-black-10">
                    0
                  </span>
                </div>
              )}
              {report?.Open > 0 ? (
                <Link
                  to={handleRedirect(
                    "/inspection-claims?result=Open&report=true",
                    false
                  )}
                >
                  <div className="flex h-24 w-full flex-col justify-center gap-2 rounded-lg border border-l-4 border-grey-10 border-l-blue-20 bg-white p-4">
                    <span className="font-InterRegular text-ft14-17 text-grey-50">
                      Open (Awaiting Action)
                    </span>
                    <span className="font-InterSemiBold text-ft25-30 text-blue-30 hover:underline">
                      {report.Open}
                    </span>
                  </div>
                </Link>
              ) : (
                <div className="flex h-24 w-full flex-col justify-center gap-2 rounded-lg border border-l-4 border-grey-10 border-l-blue-20 bg-white p-4">
                  <span className="font-InterRegular text-ft14-17 text-grey-50">
                    Open (Awaiting Action)
                  </span>
                  <span className="font-InterSemiBold text-ft25-30 text-black-10">
                    0
                  </span>
                </div>
              )}
              {report?.InProgress > 0 ? (
                <Link
                  to={handleRedirect(
                    "/inspection-claims?result=InProgress&report=true",
                    false
                  )}
                >
                  <div className="flex h-24 w-full flex-col justify-center gap-2 rounded-lg border border-l-4 border-grey-10 border-l-orange-10 bg-white p-4">
                    <span className="font-InterRegular text-ft14-17 text-grey-50">
                      In Progress
                    </span>
                    <span className="font-InterSemiBold text-ft25-30 text-blue-30 hover:underline">
                      {report.InProgress}
                    </span>
                  </div>
                </Link>
              ) : (
                <div className="flex h-24 w-full flex-col justify-center gap-2 rounded-lg border border-l-4 border-grey-10 border-l-orange-10 bg-white p-4">
                  <span className="font-InterRegular text-ft14-17 text-grey-50">
                    In Progress
                  </span>
                  <span className="font-InterSemiBold text-ft25-30 text-black-10">
                    0
                  </span>
                </div>
              )}
              {report?.Failed > 0 ? (
                <Link
                  to={handleRedirect(
                    "/inspection-claims?result=Failed&report=true",
                    false
                  )}
                >
                  <div className="flex h-24 w-full flex-col justify-center gap-2 rounded-lg border border-l-4 border-grey-10 border-l-red-10 bg-white p-4">
                    <span className="font-InterRegular text-ft14-17 text-grey-50">
                      Processing Failed
                    </span>
                    <span className="font-InterSemiBold text-ft25-30 text-blue-30 hover:underline">
                      {report.Failed}
                    </span>
                  </div>
                </Link>
              ) : (
                <div className="flex h-24 w-full flex-col justify-center gap-2 rounded-lg border border-l-4 border-grey-10 border-l-red-10 bg-white p-4">
                  <span className="font-InterRegular text-ft14-17 text-grey-50">
                    Processing Failed
                  </span>
                  <span className="font-InterSemiBold text-ft25-30 text-black-10">
                    0
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="col-span-3 xl:col-span-5">
            <h3 className="mb-3 font-InterSemiBold text-ft16-24 text-black-10">
              Gen AI Quality & SLA
            </h3>
            <div className="grid w-full grid-cols-2 gap-4 xl:grid-cols-4">
              <div className="flex w-full flex-col gap-2 rounded-lg border border-grey-10 bg-white p-4">
                <span className="font-InterRegular text-ft14-17 text-grey-50">
                  Overall Gen AI Accuracy
                </span>
                <span className="font-InterSemiBold text-ft25-30 text-blue-30">
                  {report?.damageResults?.find(
                    (item) => item.questionText === "Corrective Action"
                  )?.accuracyPercentage || 0}
                  %
                </span>
                <div className="h-1.5 w-full rounded-full bg-grey-140">
                  <div
                    className={`h-1.5 rounded-full ${getAccuracyBarClass(report?.damageResults?.find((item) => item.questionText === "Corrective Action")?.accuracyPercentage || 0)}`}
                    style={{
                      width: `${report?.damageResults?.find((item) => item.questionText === "Corrective Action")?.accuracyPercentage || 0}%`
                    }}
                  />
                </div>
                <span className="font-InterRegular text-ft12-16 text-grey-50">
                  The Overall Gen AI Accuracy based on the Feedback on the
                  Corrective Action from the SME
                </span>
              </div>

              <div className="flex w-full flex-col gap-2 rounded-lg border border-grey-10 bg-white p-4">
                <span className="font-InterRegular text-ft14-17 text-grey-50">
                  Gen AI Accuracy — ECE Queue Claims
                </span>
                <span className="font-InterSemiBold text-ft25-30 text-blue-30">
                  {report?.decisionStatus?.find(
                    (item) => item.questionText === "Corrective Action"
                  )?.overAllGenAIVsAdjuster?.genAIAccuracy || 0}
                  %
                </span>
                <div className="h-1.5 w-full rounded-full bg-grey-30">
                  <div
                    className={`h-1.5 rounded-full ${getAccuracyBarClass(report?.decisionStatus?.find((item) => item.questionText === "Corrective Action")?.overAllGenAIVsAdjuster?.genAIAccuracy || 0)}`}
                    style={{
                      width: `${report?.decisionStatus?.find((item) => item.questionText === "Corrective Action")?.overAllGenAIVsAdjuster?.genAIAccuracy || 0}%`
                    }}
                  />
                </div>
                <span className="font-InterRegular text-ft12-16 text-grey-50">
                  Claims routed to adjuster review. Overall Corrective Action
                  accuracy from the Gen AI vs. Adjuster Decisions table.
                </span>
              </div>

              <div className="flex w-full flex-col gap-2 rounded-lg border border-grey-10 bg-white p-4">
                <span className="font-InterRegular text-ft14-17 text-grey-50">
                  Gen AI Accuracy — Straight-Through (STP) Claims
                </span>
                <span className="font-InterSemiBold text-ft25-30 text-blue-30">
                  {report?.stpAccuracy?.accuracy || 0}%
                </span>
                <div className="h-1.5 w-full rounded-full bg-grey-30">
                  <div
                    className={`h-1.5 rounded-full ${getAccuracyBarClass(report?.stpAccuracy?.accuracy || 0)}`}
                    style={{ width: `${report?.stpAccuracy?.accuracy || 0}%` }}
                  />
                </div>
                <span className="font-InterRegular text-ft12-16 text-grey-50">
                  Auto-approved claims (no adjuster review), Corrective Action =
                  Replace.
                </span>
              </div>

              <div className="flex w-full flex-col gap-2 rounded-lg border border-grey-10 bg-white p-4">
                <span className="font-InterRegular text-ft14-17 text-grey-50">
                  Claims Processed On Time
                </span>
                <span className="font-InterSemiBold text-ft25-30 text-blue-30">
                  {report?.slaComplianceRate || 0}%
                </span>
                <div className="h-1.5 w-full rounded-full bg-grey-30">
                  <div
                    className={`h-1.5 rounded-full ${getAccuracyBarClass(report?.slaComplianceRate || 0)}`}
                    style={{ width: `${report?.slaComplianceRate || 0}%` }}
                  />
                </div>
                <span className="font-InterRegular text-ft12-16 text-grey-50">
                  Within SLA • {report?.processedWithinSLA || 0} on time,{" "}
                  {report?.processedOutsideSLA || 0} late
                </span>
              </div>
            </div>
          </div>

          {report?.damageResults?.length > 0 && (
            <div className="col-span-3 rounded-lg border border-grey-10 bg-white xl:col-span-5">
              <div className="flex items-center justify-between px-4 py-3">
                <div className="flex items-center gap-2">
                  <span className="font-InterSemiBold text-ft16-24 text-black-10">
                    Gen AI Accuracy — Core Damage Questions
                  </span>
                  <div className="group relative">
                    <span className="flex size-4 cursor-pointer items-center justify-center rounded-full border border-grey-50 font-InterRegular text-ft12-16 text-grey-50">
                      i
                    </span>
                    <div className="invisible absolute left-0 top-6 z-50 w-80 rounded-lg bg-black-10 p-4 text-white opacity-0 transition-opacity duration-200 group-hover:visible group-hover:opacity-100">
                      <p className="mb-2 font-InterSemiBold text-ft14-17">
                        How accuracy is calculated
                      </p>
                      <p className="mb-3 rounded bg-black-20 px-2 py-1 font-InterRegular text-ft12-16">
                        Correct ÷ (Correct + Wrong AI Response)
                      </p>
                      <div className="mb-1 flex items-start gap-2">
                        <span className="rounded bg-green-10 px-1.5 py-0.5 font-InterSemiBold text-ft12-16">
                          Correct
                        </span>
                        <span className="font-InterRegular text-ft12-16">
                          AI response is Correct
                        </span>
                      </div>
                      <div className="mb-3 flex items-start gap-2">
                        <span className="rounded bg-orange-10 px-1.5 py-0.5 font-InterSemiBold text-ft12-16">
                          Wrong AI
                        </span>
                        <span className="font-InterRegular text-ft12-16">
                          AI response was incorrect
                        </span>
                      </div>
                      <p className="font-InterRegular text-ft12-16 text-grey-20">
                        Bad Input (Data / Image) cases are excluded as they are
                        not AI errors.
                      </p>
                    </div>
                  </div>
                </div>
                <span className="font-InterRegular text-ft14-17 text-grey-50">
                  {report?.damageResults?.length} core damage questions
                </span>
              </div>
              <table className="w-full">
                <thead>
                  <tr className="border-t border-grey-30 bg-grey-80 font-InterSemiBold text-ft10-18.15 text-black-10">
                    <td className="py-2.5 pl-4">Damage Question</td>
                    <td className="py-2.5">Correct</td>
                    <td className="py-2.5">Correct (As Per Input & Rules)</td>
                    <td className="py-2.5">Incorrect Data/Image</td>
                    <td className="py-2.5">Wrong AI Response</td>
                    <td className="py-2.5">Gen AI Accuracy</td>
                    <td className="py-2.5 pr-4">Total Components</td>
                  </tr>
                </thead>
                <tbody>
                  {report?.damageResults?.map((item, idx) => {
                    return (
                      <tr key={idx} className="border-t border-grey-30">
                        <td className="w-20per py-3.5 pl-4 font-InterRegular text-ft10-18.15 text-black-10">
                          {Utils.camelToTitleCase(item?.questionText)}
                        </td>
                        <td className="w-10per font-InterRegular text-ft15-18">
                          {item?.feedbacksCount?.CORRECT > 0 ? (
                            <Link
                              className="text-blue-30 hover:underline"
                              to={handleRedirect(
                                `/inspection-claims?questionText=${item?.questionText}&reportFeedback=CORRECT&feedbackType=damageResults`
                              )}
                            >
                              {item.feedbacksCount.CORRECT}
                            </Link>
                          ) : (
                            <span className="text-black-10">0</span>
                          )}
                        </td>
                        <td className="w-10per font-InterRegular text-ft15-18">
                          {item?.feedbacksCount
                            ?.GEN_AI_CORRECT_INSUFFICIENT_INPUTS > 0 ? (
                            <Link
                              className="text-blue-30 hover:underline"
                              to={handleRedirect(
                                `/inspection-claims?questionText=${item?.questionText}&reportFeedback=GEN_AI_CORRECT_INSUFFICIENT_INPUTS&feedbackType=damageResults`
                              )}
                            >
                              {
                                item.feedbacksCount
                                  .GEN_AI_CORRECT_INSUFFICIENT_INPUTS
                              }
                            </Link>
                          ) : (
                            <span className="text-black-10">0</span>
                          )}
                        </td>
                        <td className="w-10per font-InterRegular text-ft15-18">
                          {item?.feedbacksCount?.INCORRECT_DATA_IMAGE > 0 ? (
                            <Link
                              to={handleRedirect(
                                `/inspection-claims?questionText=${item?.questionText}&reportFeedback=INCORRECT_DATA_IMAGE&feedbackType=damageResults`
                              )}
                              className="text-blue-30 hover:underline"
                            >
                              {item.feedbacksCount.INCORRECT_DATA_IMAGE}
                            </Link>
                          ) : (
                            <span className="text-black-10">0</span>
                          )}
                        </td>
                        <td className="w-10per font-InterRegular text-ft15-18">
                          {item?.feedbacksCount?.INCORRECT_AI_RESPONSE > 0 ? (
                            <Link
                              to={handleRedirect(
                                `/inspection-claims?questionText=${item?.questionText}&reportFeedback=INCORRECT_AI_RESPONSE&feedbackType=damageResults`
                              )}
                              className="text-blue-30 hover:underline"
                            >
                              {item.feedbacksCount.INCORRECT_AI_RESPONSE}
                            </Link>
                          ) : (
                            <span className="text-black-10">0</span>
                          )}
                        </td>
                        <td className="w-15per font-InterRegular text-ft15-18 text-black-10">
                          <div className="flex items-center gap-2">
                            <span
                              className={`inline-block min-w-[76px] rounded-lg px-3 py-1 text-center font-InterMedium text-ft14-17 ${getAccuracyClasses(item.accuracyPercentage)}`}
                            >
                              {item.accuracyPercentage > 0
                                ? `${item.accuracyPercentage}%`
                                : "0%"}
                            </span>
                            <div className="h-2 w-16 overflow-hidden rounded-full bg-grey-140">
                              <div
                                className={`h-full rounded-full transition-all duration-500 ease-in-out ${getAccuracyBarClass(item.accuracyPercentage)}`}
                                style={{
                                  width: `${item.accuracyPercentage || 0}%`
                                }}
                              />
                            </div>
                          </div>
                        </td>
                        <td className="w-10per pr-4 font-InterRegular text-ft15-18 text-black-10">
                          {item?.total || 0}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {report?.decisionStatus?.length > 0 &&
            (() => {
              const caItem = report.decisionStatus.find(
                (d) => d.questionText === "Corrective Action"
              );
              return (
                <div className="col-span-3 rounded-lg border border-grey-10 bg-white xl:col-span-5">
                  <div className="flex flex-wrap items-start justify-between gap-3 px-4 py-3">
                    <div className="flex items-center gap-2">
                      <span className="font-InterSemiBold text-ft16-24 text-black-10">
                        Gen AI vs. Adjuster Decision
                      </span>
                      <div className="group relative">
                        <span className="flex size-4 cursor-pointer items-center justify-center rounded-full border border-grey-50 font-InterRegular text-ft12-16 text-grey-50">
                          i
                        </span>
                        <div className="invisible absolute left-0 top-6 z-50 w-80 rounded-lg bg-black-10 p-4 text-white opacity-0 transition-opacity duration-200 group-hover:visible group-hover:opacity-100">
                          <p className="mb-3 font-InterSemiBold text-ft14-17">
                            What each metric means
                          </p>
                          <div className="mb-3">
                            <span className="font-InterSemiBold text-ft12-16 text-green-10">
                              Acceptance Accuracy
                            </span>
                            <span className="ml-2 font-InterRegular text-ft12-16">
                              Of the claims the adjuster accepted, how often
                              they got it right
                            </span>
                          </div>
                          <div className="mb-3">
                            <span className="font-InterSemiBold text-ft12-16 text-blue-10">
                              Override Accuracy
                            </span>
                            <span className="ml-2 font-InterRegular text-ft12-16">
                              Of the claims the adjuster overrode, how often
                              they got it right
                            </span>
                          </div>
                          <div className="mb-3">
                            <span className="font-InterSemiBold text-ft12-16 text-red-10">
                              Adjuster Error
                            </span>
                            <span className="ml-2 font-InterRegular text-ft12-16">
                              100% minus the above — how often the
                              adjuster&apos;s decision was wrong
                            </span>
                          </div>
                          <p className="font-InterRegular text-ft12-16 text-grey-20">
                            Corrective Action is the headline metric for Gen AI
                            performance.
                          </p>
                        </div>
                      </div>
                      <span className="font-InterRegular text-ft14-17 text-grey-50">
                        Adjuster actions on Gen AI suggestions
                      </span>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      <span
                        className={`rounded-full px-3 py-1 font-InterRegular text-ft12-16 ${getAccuracyClasses(caItem?.overAllGenAIVsAdjuster?.genAIAccuracy || 0)}`}
                      >
                        Overall Gen AI vs. Adjuster Decision • Corrective Action
                        • Gen AI Accuracy{" "}
                        <span className="font-InterSemiBold">
                          {caItem?.overAllGenAIVsAdjuster?.genAIAccuracy || 0}%
                        </span>
                      </span>
                      <span
                        className={`rounded-full px-3 py-1 font-InterRegular text-ft12-16 ${getAccuracyClasses(caItem?.overAllGenAIVsAdjuster?.adjusterErrorRate || 0)}`}
                      >
                        Overall Gen AI vs. Adjuster Decision • Corrective Action
                        • Adjuster Error Rate{" "}
                        <span className="font-InterSemiBold">
                          {caItem?.overAllGenAIVsAdjuster?.adjusterErrorRate ||
                            0}
                          %
                        </span>
                      </span>
                    </div>
                  </div>

                  <div className="border-t border-grey-30 px-4 py-3">
                    <div className="flex flex-wrap items-center justify-between gap-2">
                      <div className="flex items-center gap-2">
                        <span className="font-InterSemiBold text-ft15-18 text-black-10">
                          Accepted by Adjuster
                        </span>
                        <span className="font-InterRegular text-ft12-16 text-grey-50">
                          Adjuster agreed with Gen AI&apos;s Suggestion
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        <span
                          className={`rounded-full px-3 py-1 font-InterRegular text-ft12-16 ${getAccuracyClasses(caItem?.acceptedByAdjuster?.genAIAccuracy || 0)}`}
                        >
                          Corrective Action • Gen AI Accuracy{" "}
                          <span className="font-InterSemiBold">
                            {caItem?.acceptedByAdjuster?.genAIAccuracy || 0}%
                          </span>
                        </span>
                        <span
                          className={`rounded-full px-3 py-1 font-InterRegular text-ft12-16 ${getAccuracyClasses(caItem?.acceptedByAdjuster?.acceptanceErrorRate || 0)}`}
                        >
                          Corrective Action • Acceptance Error Rate{" "}
                          <span className="font-InterSemiBold">
                            {caItem?.acceptedByAdjuster?.acceptanceErrorRate ||
                              0}
                            %
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="mt-2 overflow-x-auto">
                      <table className="w-full table-fixed">
                        <colgroup>
                          <col style={{ width: "14%" }} />
                          <col style={{ width: "11%" }} />
                          <col style={{ width: "15%" }} />
                          <col style={{ width: "18%" }} />
                          <col style={{ width: "14%" }} />
                          <col style={{ width: "10%" }} />
                          <col style={{ width: "10%" }} />
                          <col style={{ width: "8%" }} />
                        </colgroup>
                        <thead>
                          <tr className="border-t border-grey-30 bg-grey-80 font-InterSemiBold text-ft10-18.15 text-black-10">
                            <td className="py-2.5 pl-4">Damage Question</td>
                            <td className="py-2.5">
                              Total Gen AI Decision Accepted by Adjuster
                            </td>
                            <td className="py-2.5">
                              SME Feedback (Correctly Accepted where Gen AI is
                              Correct)
                            </td>
                            <td className="py-2.5">
                              SME Feedback (Incorrectly Accepted where Gen AI is
                              Correct Based on the Current Input,Context,Rules)
                            </td>
                            <td className="py-2.5">
                              SME Feedback (Incorrectly Accepted where Gen AI is
                              Incorrect)
                            </td>
                            <td className="py-2.5">Acceptance Accuracy (%)</td>
                            <td className="py-2.5">
                              Acceptance Error Rate (%)
                            </td>
                            <td className="py-2.5 pr-4">Gen AI Accuracy (%)</td>
                          </tr>
                        </thead>
                        <tbody>
                          {report.decisionStatus.map((item, idx) => (
                            <tr key={idx} className="border-t border-grey-30">
                              <td className="py-3.5 pl-4 font-InterRegular text-ft10-18.15 text-black-10">
                                {item?.questionText || ""}
                              </td>
                              <td className="py-3.5 font-InterRegular text-ft15-18 text-black-10">
                                {/* <Link
                                  className="text-blue-30 hover:underline"
                                  to={handleRedirect(
                                    `/inspection-claims?questionText=${item?.questionText}&reportFeedback=CORRECT&feedbackType=additionalQuestions`
                                  )}
                                > */}
                                {item?.acceptedByAdjuster?.totalAccepted || 0}
                                {/* </Link> */}
                              </td>
                              <td className="py-3.5 font-InterRegular text-ft15-18 text-black-10">
                                {item?.acceptedByAdjuster
                                  ?.correctlyAcceptedGenAICorrect > 0 ? (
                                  <Link
                                    className="text-blue-30 hover:underline"
                                    to={handleRedirect(
                                      `/inspection-claims?questionText=${item?.questionText}&reportFeedback=CORRECTLY_ACCEPTED_GEN_AI_CORRECT&feedbackType=decisionStatus`
                                    )}
                                  >
                                    {
                                      item.acceptedByAdjuster
                                        .correctlyAcceptedGenAICorrect
                                    }
                                  </Link>
                                ) : (
                                  <span>0</span>
                                )}
                              </td>
                              <td className="py-3.5 font-InterRegular text-ft15-18 text-black-10">
                                {item?.acceptedByAdjuster
                                  ?.incorrectlyAcceptedGenAICorrect > 0 ? (
                                  <Link
                                    className="text-blue-30 hover:underline"
                                    to={handleRedirect(
                                      `/inspection-claims?questionText=${item?.questionText}&reportFeedback=INCORRECTLY_ACCEPTED_GEN_AI_CORRECT&feedbackType=decisionStatus`
                                    )}
                                  >
                                    {
                                      item.acceptedByAdjuster
                                        .incorrectlyAcceptedGenAICorrect
                                    }
                                  </Link>
                                ) : (
                                  <span>0</span>
                                )}
                              </td>
                              <td className="py-3.5 font-InterRegular text-ft15-18 text-black-10">
                                {item?.acceptedByAdjuster
                                  ?.incorrectlyAcceptedGenAIIncorrect > 0 ? (
                                  <Link
                                    className="text-blue-30 hover:underline"
                                    to={handleRedirect(
                                      `/inspection-claims?questionText=${item?.questionText}&reportFeedback=INCORRECTLY_ACCEPTED_GEN_AI_INCORRECT&feedbackType=decisionStatus`
                                    )}
                                  >
                                    {
                                      item.acceptedByAdjuster
                                        .incorrectlyAcceptedGenAIIncorrect
                                    }
                                  </Link>
                                ) : (
                                  <span>0</span>
                                )}
                              </td>
                              <td className="py-3.5 font-InterRegular text-ft15-18">
                                <span
                                  className={`inline-block min-w-[76px] rounded-lg px-3 py-1 text-center font-InterMedium text-ft14-17 ${getAccuracyClasses(item?.acceptedByAdjuster?.acceptanceAccuracy || 0)}`}
                                >
                                  {item?.acceptedByAdjuster
                                    ?.acceptanceAccuracy || 0}
                                  %
                                </span>
                              </td>
                              <td className="py-3.5 font-InterRegular text-ft15-18">
                                <span
                                  className={`inline-block min-w-[76px] rounded-lg px-3 py-1 text-center font-InterMedium text-ft14-17 ${getAccuracyClasses(item?.acceptedByAdjuster?.acceptanceErrorRate || 0)}`}
                                >
                                  {item?.acceptedByAdjuster
                                    ?.acceptanceErrorRate || 0}
                                  %
                                </span>
                              </td>
                              <td className="py-3.5 pr-4 font-InterRegular text-ft15-18">
                                <span
                                  className={`inline-block min-w-[76px] rounded-lg px-3 py-1 text-center font-InterMedium text-ft14-17 ${getAccuracyClasses(item?.acceptedByAdjuster?.genAIAccuracy || 0)}`}
                                >
                                  {item?.acceptedByAdjuster?.genAIAccuracy || 0}
                                  %
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="border-t border-grey-30 px-4 py-3">
                    <div className="flex flex-wrap items-center justify-between gap-2">
                      <div className="flex items-center gap-2">
                        <span className="font-InterSemiBold text-ft15-18 text-black-10">
                          Overridden by Adjuster
                        </span>
                        <span className="font-InterRegular text-ft12-16 text-grey-50">
                          Adjuster Override the Gen AI&apos;s Suggestion
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        <span
                          className={`rounded-full px-3 py-1 font-InterRegular text-ft12-16 ${getAccuracyClasses(caItem?.overriddenByAdjuster?.genAIAccuracy || 0)}`}
                        >
                          Corrective Action • Gen AI Accuracy{" "}
                          <span className="font-InterSemiBold">
                            {caItem?.overriddenByAdjuster?.genAIAccuracy || 0}%
                          </span>
                        </span>
                        <span
                          className={`rounded-full px-3 py-1 font-InterRegular text-ft12-16 ${getAccuracyClasses(caItem?.overriddenByAdjuster?.overrideErrorRate || 0)}`}
                        >
                          Corrective Action • Override Error Rate{" "}
                          <span className="font-InterSemiBold">
                            {caItem?.overriddenByAdjuster?.overrideErrorRate ||
                              0}
                            %
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="mt-2 overflow-x-auto">
                      <table className="w-full table-fixed">
                        <colgroup>
                          <col style={{ width: "14%" }} />
                          <col style={{ width: "11%" }} />
                          <col style={{ width: "15%" }} />
                          <col style={{ width: "18%" }} />
                          <col style={{ width: "14%" }} />
                          <col style={{ width: "10%" }} />
                          <col style={{ width: "10%" }} />
                          <col style={{ width: "8%" }} />
                        </colgroup>
                        <thead>
                          <tr className="border-t border-grey-30 bg-grey-80 font-InterSemiBold text-ft10-18.15 text-black-10">
                            <td className="py-2.5 pl-4">Damage Question</td>
                            <td className="py-2.5">
                              Total Gen AI Decision Overridden by the Adjuster
                            </td>
                            <td className="py-2.5">
                              SME Feedback (Correctly Overridden where Gen AI is
                              Incorrect)
                            </td>
                            <td className="py-2.5">
                              SME Feedback (Correctly Overridden where Gen AI is
                              Correct Based on the Current Input,Context,Rules)
                            </td>
                            <td className="py-2.5">
                              SME Feedback (Incorrectly Overridden where Gen AI
                              is Correct)
                            </td>
                            <td className="py-2.5">Override Accuracy (%)</td>
                            <td className="py-2.5">Override Error Rate (%)</td>
                            <td className="py-2.5 pr-4">Gen AI Accuracy (%)</td>
                          </tr>
                        </thead>
                        <tbody>
                          {report.decisionStatus.map((item, idx) => (
                            <tr key={idx} className="border-t border-grey-30">
                              <td className="py-3.5 pl-4 font-InterRegular text-ft10-18.15 text-black-10">
                                {item?.questionText || ""}
                              </td>
                              <td className="py-3.5 font-InterRegular text-ft15-18 text-black-10">
                                {" "}
                                {item?.overriddenByAdjuster?.totalOverridden ||
                                  0}
                              </td>
                              <td className="py-3.5 font-InterRegular text-ft15-18 text-black-10">
                                {item?.overriddenByAdjuster
                                  ?.correctlyOverriddenGenAIIncorrect > 0 ? (
                                  <Link
                                    className="text-blue-30 hover:underline"
                                    to={handleRedirect(
                                      `/inspection-claims?questionText=${item?.questionText}&reportFeedback=CORRECTLY_OVERRIDDEN_GEN_AI_INCORRECT&feedbackType=decisionStatus`
                                    )}
                                  >
                                    {
                                      item.overriddenByAdjuster
                                        .correctlyOverriddenGenAIIncorrect
                                    }
                                  </Link>
                                ) : (
                                  <span>0</span>
                                )}
                              </td>
                              <td className="py-3.5 font-InterRegular text-ft15-18 text-black-10">
                                {item?.overriddenByAdjuster
                                  ?.correctlyOverriddenGenAICorrect > 0 ? (
                                  <Link
                                    className="text-blue-30 hover:underline"
                                    to={handleRedirect(
                                      `/inspection-claims?questionText=${item?.questionText}&reportFeedback=CORRECTLY_OVERRIDDEN_GEN_AI_CORRECT&feedbackType=decisionStatus`
                                    )}
                                  >
                                    {
                                      item.overriddenByAdjuster
                                        .correctlyOverriddenGenAICorrect
                                    }
                                  </Link>
                                ) : (
                                  <span>0</span>
                                )}
                              </td>
                              <td className="py-3.5 font-InterRegular text-ft15-18 text-black-10">
                                {item?.overriddenByAdjuster
                                  ?.incorrectlyOverriddenGenAICorrect > 0 ? (
                                  <Link
                                    className="text-blue-30 hover:underline"
                                    to={handleRedirect(
                                      `/inspection-claims?questionText=${item?.questionText}&reportFeedback=INCORRECTLY_OVERRIDDEN_GEN_AI_CORRECT&feedbackType=decisionStatus`
                                    )}
                                  >
                                    {
                                      item.overriddenByAdjuster
                                        .incorrectlyOverriddenGenAICorrect
                                    }
                                  </Link>
                                ) : (
                                  <span>0</span>
                                )}
                              </td>
                              <td className="py-3.5 font-InterRegular text-ft15-18">
                                <span
                                  className={`inline-block min-w-[76px] rounded-lg px-3 py-1 text-center font-InterMedium text-ft14-17 ${getAccuracyClasses(item?.overriddenByAdjuster?.overrideAccuracy || 0)}`}
                                >
                                  {item?.overriddenByAdjuster
                                    ?.overrideAccuracy || 0}
                                  %
                                </span>
                              </td>
                              <td className="py-3.5 font-InterRegular text-ft15-18">
                                <span
                                  className={`inline-block min-w-[76px] rounded-lg px-3 py-1 text-center font-InterMedium text-ft14-17 ${getAccuracyClasses(item?.overriddenByAdjuster?.overrideErrorRate || 0)}`}
                                >
                                  {item?.overriddenByAdjuster
                                    ?.overrideErrorRate || 0}
                                  %
                                </span>
                              </td>
                              <td className="py-3.5 pr-4 font-InterRegular text-ft15-18">
                                <span
                                  className={`inline-block min-w-[76px] rounded-lg px-3 py-1 text-center font-InterMedium text-ft14-17 ${getAccuracyClasses(item?.overriddenByAdjuster?.genAIAccuracy || 0)}`}
                                >
                                  {item?.overriddenByAdjuster?.genAIAccuracy ||
                                    0}
                                  %
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              );
            })()}

          {report?.additionalQuestions?.length > 0 && (
            <div className="col-span-3 rounded-lg border border-grey-10 bg-white xl:col-span-5">
              <div className="flex items-center justify-between px-4 py-3">
                <div className="flex items-center gap-2">
                  <span className="font-InterSemiBold text-ft16-24 text-black-10">
                    Additional Questions
                  </span>
                  <div className="group relative">
                    <span className="flex size-4 cursor-pointer items-center justify-center rounded-full border border-grey-50 font-InterRegular text-ft12-16 text-grey-50">
                      i
                    </span>
                    <div className="invisible absolute left-0 top-6 z-50 w-80 rounded-lg bg-black-10 p-4 text-white opacity-0 transition-opacity duration-200 group-hover:visible group-hover:opacity-100">
                      <p className="mb-2 font-InterSemiBold text-ft14-17">
                        How accuracy is calculated
                      </p>
                      <p className="mb-3 rounded bg-black-20 px-2 py-1 font-InterRegular text-ft12-16">
                        Correct ÷ (Correct + Wrong AI Response)
                      </p>
                      <div className="mb-1 flex items-start gap-2">
                        <span className="rounded bg-green-10 px-1.5 py-0.5 font-InterSemiBold text-ft12-16">
                          Correct
                        </span>
                        <span className="font-InterRegular text-ft12-16">
                          AI response is Correct
                        </span>
                      </div>
                      <div className="mb-3 flex items-start gap-2">
                        <span className="rounded bg-orange-10 px-1.5 py-0.5 font-InterSemiBold text-ft12-16">
                          Wrong AI
                        </span>
                        <span className="font-InterRegular text-ft12-16">
                          AI response was incorrect
                        </span>
                      </div>
                      <p className="font-InterRegular text-ft12-16 text-grey-20">
                        Bad Input (Data / Image) cases are excluded as they are
                        not AI errors.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <table className="w-full">
                <thead>
                  <tr className="border-t border-grey-30 bg-grey-80 font-InterSemiBold text-ft10-18.15 text-black-10">
                    <td className="py-2.5 pl-4">Question</td>
                    <td className="py-2.5">Correct</td>
                    <td className="py-2.5">Correct (As Per Input & Rules)</td>
                    <td className="py-2.5">Incorrect Data/Image</td>
                    <td className="py-2.5">Wrong AI Response</td>
                    <td className="py-2.5">Gen AI Accuracy</td>
                    <td className="py-2.5 pr-4">Total Components</td>
                  </tr>
                </thead>
                <tbody>
                  {[...(report?.additionalQuestions || [])]
                    .sort(
                      (a, b) =>
                        (b.accuracyPercentage || 0) -
                        (a.accuracyPercentage || 0)
                    )
                    .map((item, idx) => {
                      return (
                        <tr key={idx} className="border-t border-grey-30">
                          <td className="w-30per py-3.5 pl-4 font-InterRegular text-ft10-18.15 text-black-10">
                            {Utils.camelToTitleCase(item?.questionText)}
                          </td>
                          <td className="w-10per font-InterRegular text-ft15-18">
                            {item?.feedbacksCount?.CORRECT > 0 ? (
                              <Link
                                className="text-blue-30 hover:underline"
                                to={handleRedirect(
                                  `/inspection-claims?questionText=${item?.questionText}&reportFeedback=CORRECT&feedbackType=additionalQuestions`
                                )}
                              >
                                {item.feedbacksCount.CORRECT}
                              </Link>
                            ) : (
                              <span className="text-black-10">0</span>
                            )}
                          </td>
                          <td className="w-10per font-InterRegular text-ft15-18">
                            {item?.feedbacksCount
                              ?.GEN_AI_CORRECT_INSUFFICIENT_INPUTS > 0 ? (
                              <Link
                                className="text-blue-30 hover:underline"
                                to={handleRedirect(
                                  `/inspection-claims?questionText=${item?.questionText}&reportFeedback=GEN_AI_CORRECT_INSUFFICIENT_INPUTS&feedbackType=additionalQuestions`
                                )}
                              >
                                {
                                  item.feedbacksCount
                                    .GEN_AI_CORRECT_INSUFFICIENT_INPUTS
                                }
                              </Link>
                            ) : (
                              <span className="text-black-10">0</span>
                            )}
                          </td>
                          <td className="w-10per font-InterRegular text-ft15-18 text-black-10">
                            {item?.feedbacksCount?.INCORRECT_DATA_IMAGE > 0 ? (
                              <Link
                                to={handleRedirect(
                                  `/inspection-claims?questionText=${item?.questionText}&reportFeedback=INCORRECT_DATA_IMAGE&feedbackType=additionalQuestions`
                                )}
                                className="text-blue-30 hover:underline"
                              >
                                {item.feedbacksCount.INCORRECT_DATA_IMAGE}
                              </Link>
                            ) : (
                              <span>0</span>
                            )}
                          </td>
                          <td className="w-10per font-InterRegular text-ft15-18 text-black-10">
                            {item?.feedbacksCount?.INCORRECT_AI_RESPONSE > 0 ? (
                              <Link
                                to={handleRedirect(
                                  `/inspection-claims?questionText=${item?.questionText}&reportFeedback=INCORRECT_AI_RESPONSE&feedbackType=additionalQuestions`
                                )}
                                className="text-blue-30 hover:underline"
                              >
                                {item.feedbacksCount.INCORRECT_AI_RESPONSE}
                              </Link>
                            ) : (
                              <span>0</span>
                            )}
                          </td>
                          <td className="w-15per font-InterRegular text-ft15-18 text-black-10">
                            <div className="inline-flex flex-col gap-1">
                              <span
                                className={`inline-block min-w-[76px] rounded-lg px-3 py-1 text-center font-InterMedium text-ft14-17 ${getAccuracyClasses(item.accuracyPercentage)}`}
                              >
                                {item.accuracyPercentage > 0
                                  ? `${item.accuracyPercentage}%`
                                  : "0%"}
                              </span>
                              <div className="h-2 min-w-[76px] overflow-hidden rounded-full bg-grey-140">
                                <div
                                  className={`h-full rounded-full transition-all duration-500 ease-in-out ${getAccuracyBarClass(item.accuracyPercentage)}`}
                                  style={{
                                    width: `${item.accuracyPercentage || 0}%`
                                  }}
                                />
                              </div>
                            </div>
                          </td>
                          <td className="w-10per pr-4 font-InterRegular text-ft15-18 text-black-10">
                            {item?.total || 0}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Report;
